export const cropText = (str, len = 55) =>
  str && str.length > len ? `${str.substr(0, len)}..` : str;

export const uppercaseFirstLetter = (str = "") => {
  if (!str) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
